/* Makemake Studio 3.0: small progressive enhancements. No dependencies. */
(function () {
  function initTabs(root) {
    if (root.dataset.studioTabsReady) return;
    root.dataset.studioTabsReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-studio-tabs]').forEach(initTabs);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* Studio 3.0: "1 / N" photo counter on phones. The carousel marks the visible
   slide with .is-selected, so watch for that rather than reaching into its API. */
(function () {
  function initCounter(count) {
    var gallery = count.parentElement;
    var slider = gallery && gallery.querySelector('[data-product-single-media-slider]');
    var current = count.querySelector('[data-studio-gallery-current]');
    if (!slider || !current) return;
    var update = function () {
      var slides = slider.querySelectorAll('.product-gallery__media-slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-selected')) {
          current.textContent = String(i + 1);
          return;
        }
      }
    };
    new MutationObserver(update).observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
    update();
  }
  function initAll() {
    document.querySelectorAll('[data-studio-gallery-count]:not([data-studio-ready])').forEach(function (count) {
      count.setAttribute('data-studio-ready', '');
      initCounter(count);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

/* Keep friendly size labels in popout toggles after theme JS writes the raw option value */
(function () {
  function bind(popout) {
    if (popout.hasAttribute('data-studio-labels')) return;
    var text = popout.querySelector('[data-popout-text]');
    if (!text) return;
    var map = {};
    popout.querySelectorAll('[data-popout-option][data-value]').forEach(function (opt) {
      var span = opt.querySelector('span');
      var label = span ? span.textContent.trim() : '';
      var raw = opt.getAttribute('data-value');
      if (label && raw && label !== raw) map[raw] = label;
    });
    if (!Object.keys(map).length) return;
    popout.setAttribute('data-studio-labels', '');
    var fix = function () {
      var current = text.textContent.trim();
      if (map[current]) text.textContent = map[current];
    };
    new MutationObserver(fix).observe(text, { childList: true, characterData: true, subtree: true });
    fix();
  }
  function init() {
    document.querySelectorAll('popout-select').forEach(bind);
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();

/* Friendly note when a cart quantity is capped by available stock */
(function () {
  var pending = {};
  function lineFor(key) {
    var field = document.getElementById('updates_' + key);
    return field ? field.closest('[data-cart-item]') : null;
  }
  function show() {
    Object.keys(pending).forEach(function (key) {
      var line = lineFor(key);
      if (!line || line.querySelector('.studio-qty-note')) return;
      var note = document.createElement('p');
      note.className = 'studio-qty-note';
      note.setAttribute('role', 'status');
      var limit = pending[key];
      note.textContent = limit > 0
        ? 'Only ' + limit + ' available, so we’ve updated your quantity.'
        : 'This item is now sold out.';
      var bottom = line.querySelector('.cart__item__bottom') || line;
      bottom.insertAdjacentElement('afterend', note);
    });
  }
  function record(field, requested) {
    if (!field.hasAttribute('data-studio-stock-limit') || !field.closest('[data-cart-item]')) return;
    var limit = parseInt(field.getAttribute('data-studio-stock-limit'), 10);
    if (isNaN(limit) || requested <= limit) return;
    var key = field.getAttribute('data-id');
    pending[key] = Math.max(limit, 0);
    setTimeout(function () { delete pending[key]; }, 10000);
  }
  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('[data-quantity-plus]');
    if (!plus) return;
    var holder = plus.closest('[data-quantity-holder]');
    var field = holder && holder.querySelector('[data-quantity-field]');
    if (field) record(field, (parseInt(field.value, 10) || 0) + 1);
  }, true);
  document.addEventListener('input', function (e) {
    var field = e.target;
    if (field.matches && field.matches('[data-quantity-field]')) record(field, parseInt(field.value, 10) || 0);
  }, true);
  new MutationObserver(function () {
    if (Object.keys(pending).length) show();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Keep the Growave rewards launcher clear of the sticky add-to-cart bar on phones */
(function () {
  var tries = 0;
  function launcher() {
    var host = document.querySelector('.gw-rd-popup-widget-placeholder');
    var root = host && host.shadowRoot;
    return root ? root.querySelector('.gw-rd-popup-widget-launcher') : null;
  }
  function place(el) {
    var bar = document.querySelector('.cart-bar.is-visible');
    var lift = window.matchMedia('(max-width: 749px)').matches && bar ? bar.offsetHeight + 12 : 0;
    el.style.transition = 'bottom .2s ease';
    el.style.bottom = (10 + lift) + 'px';
  }
  function start() {
    var el = launcher();
    if (!el) {
      if (++tries < 40) setTimeout(start, 500);
      return;
    }
    place(el);
    var bar = document.querySelector('.cart-bar');
    if (bar) new MutationObserver(function () { place(el); }).observe(bar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', function () { place(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Studio 3.0 print selector: view all, hover name preview, keep size when switching prints */
(function () {
  var KEY = 'studioPrintSize';

  function sizeInput(scope) {
    var form = (scope && scope.closest('.product-single, [data-section-type="product"], .product__wrapper')) || document;
    var els = form.querySelectorAll('input[name^="options["]:checked, select[name^="options["]');
    for (var i = 0; i < els.length; i++) {
      var m = /^options\[(.+)\]$/.exec(els[i].name);
      if (m && /^size$/i.test(m[1].trim())) return { el: els[i], option: m[1].trim() };
    }
    return null;
  }

  // "0-3 Months" and "0-3M" are the same size across older and newer prints
  function sizeKey(value) {
    return String(value || '').toLowerCase().replace(/\s*months?\b/g, 'm').replace(/\s+/g, '');
  }

  function sizeLabel(input) {
    if (input.el.tagName === 'SELECT') {
      var opt = input.el.options[input.el.selectedIndex];
      return opt ? opt.textContent.trim() : input.el.value;
    }
    var label = document.querySelector('label[for="' + input.el.id + '"]');
    return label ? label.textContent.trim() : input.el.value;
  }

  function init(root) {
    if (root.dataset.studioPrintsReady) return;
    root.dataset.studioPrintsReady = '1';
    var list = root.querySelector('[data-studio-prints-list]');
    var current = root.querySelector('[data-studio-prints-current]');
    var more = root.querySelector('[data-studio-prints-more]');
    var currentText = current ? current.textContent : '';

    if (more) {
      more.addEventListener('click', function () {
        var open = list.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.querySelector('[data-more-closed]').hidden = open;
        more.querySelector('[data-more-open]').hidden = !open;
      });
    }

    root.querySelectorAll('.studio-prints__swatch').forEach(function (a) {
      var preview = function () { if (current) current.textContent = a.dataset.printName; };
      var restore = function () { if (current) current.textContent = currentText; };
      var prefetched = false;
      var prefetch = function () {
        if (prefetched || a.getAttribute('aria-current')) return;
        prefetched = true;
        var l = document.createElement('link');
        l.rel = 'prefetch'; l.href = a.href;
        document.head.appendChild(l);
      };
      a.addEventListener('mouseenter', function () { preview(); prefetch(); });
      a.addEventListener('focus', function () { preview(); prefetch(); });
      a.addEventListener('mouseleave', restore);
      a.addEventListener('blur', restore);
      a.addEventListener('touchstart', prefetch, { passive: true });

      a.addEventListener('click', function (e) {
        if (a.getAttribute('aria-current') || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        var input = sizeInput(root);
        if (!input || !input.el.value) return;
        e.preventDefault();
        var want = sizeKey(input.el.value);
        var label = sizeLabel(input);
        var go = function (url, missing) {
          try {
            if (missing) sessionStorage.setItem(KEY, JSON.stringify({ handle: a.dataset.handle, size: label }));
            else sessionStorage.removeItem(KEY);
          } catch (err) {}
          window.location.href = url;
        };
        fetch('/products/' + a.dataset.handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (p) {
            var idx = -1;
            (p.options || []).forEach(function (o, i) {
              var name = typeof o === 'string' ? o : o.name;
              if (name && name.toLowerCase() === input.option.toLowerCase()) idx = i;
            });
            var match = null;
            if (idx > -1) {
              p.variants.forEach(function (v) {
                if (!match && sizeKey(v.options[idx]) === want && v.available) match = v;
              });
            }
            if (match) go(a.href + (a.href.indexOf('?') > -1 ? '&' : '?') + 'variant=' + match.id, false);
            else go(a.href, true);
          })
          .catch(function () { go(a.href, false); });
      });
    });

    // Arriving from another print whose size isn't available here
    try {
      var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      var here = root.querySelector('.studio-prints__swatch[aria-current="true"]');
      if (saved && here && saved.handle === here.dataset.handle) {
        sessionStorage.removeItem(KEY);
        var note = root.querySelector('[data-studio-prints-note]');
        if (note) {
          note.textContent = saved.size ? note.dataset.msgMissing.replace('__SIZE__', saved.size) : note.dataset.msgPick;
          note.hidden = false;
        }
      }
    } catch (err) {}
  }

  function run() { document.querySelectorAll('[data-studio-prints]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

/* Bedding "See dimensions" link: open and scroll to the Dimensions row */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-studio-dims-link]');
    if (!link) return;
    var triggers = document.querySelectorAll('[data-collapsible-trigger]');
    var target = null;
    for (var i = 0; i < triggers.length; i++) {
      if (/dimension/i.test(triggers[i].textContent) && triggers[i].offsetParent !== null) { target = triggers[i]; break; }
    }
    if (!target) return;
    event.preventDefault();
    if (target.getAttribute('aria-expanded') !== 'true') target.click();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.focus({ preventScroll: true });
  });
})();
